
import { TwoColumnLayout } from '../global'

const BespokeShoppingServiceSection = () => {
  const content = (
    <>
      <p style={{ marginBottom: '24px' }}>
        Experience effortless luxury shopping – FGA Prestige's Bespoke Shopping
        Service offers a highly personalised, one-to-one journey designed
        exclusively around individual style and aspirations.
      </p>
      <p>
        Clients are matched with a dedicated personal shopper whose deep
        expertise and network of industry insiders unlock unparalleled access to
        the world's most coveted pieces, from limited-edition designer bags to
        custom Rolex watches.
      </p>
    </>
  )

  return (
    <TwoColumnLayout
      title="Bespoke Shopping Service"
      content={content}
      imageSrc="/Bespoke Shopping/Bespoke Shopping Service.png"
      imageAlt="Bespoke Shopping Service - Personal shopping consultation"
      imageFirst={true}
      backgroundColor="#FFFFFF"
      titleColor="#111"
      textColor="#7B7B7B"
      titleSize="40px"
    />
  )
}

export default BespokeShoppingServiceSection